import { IHeartRate } from 'fitbeat.models';
import { HeartRateData } from '../../../logic/performancemetrics/HeartRateData';
import { IWorkoutHeartRateDataRepository } from '../interfaces';
import { PouchDbQueryHelper } from './pouchdb-query-helper';

export class DbWorkoutHeartRateData implements IWorkoutHeartRateDataRepository {
  private queryDb: PouchDbQueryHelper;

  constructor(private db: any, logger?: any) {
    this.queryDb = new PouchDbQueryHelper(db, 'DbWorkoutHeartRateData', logger);
  }

  public async add(workoutId: string, heartRatePoints: IHeartRate[]): Promise<HeartRateData> {
    const mappedHeartRatePoints = heartRatePoints.map((heartRate: IHeartRate) => {
      return [heartRate.heartRate, heartRate.timestamp];
    });
    const doc = {
      _id: workoutId,
      heartRateDataPoints: mappedHeartRatePoints,
    };
    await this.db.put(doc);
    return new HeartRateData(workoutId, mappedHeartRatePoints);
  }

  public async getAll(workoutIds: string[]): Promise<HeartRateData[]> {
    if (workoutIds.length === 0) {
      return [];
    }

    const queryOptions = {
      limit: 10000,
      selector: {
        _id: {
          $in: workoutIds,
        },
        ['heartRateDataPoints.0']: {
          $exists: true,
        },
        ['heartRateDataPoints.0.1']: {
          $lt: '1971-01-01T00:00:00.000Z',
        },
      },
    };

    const resultDocs: any = await this.queryDb.queryAndGetDocs(`getAll(${workoutIds.length} workoutIds)`, queryOptions);
    const heartRateData: HeartRateData[] = resultDocs.map((doc: any) =>
      new HeartRateData(doc._id, doc.heartRateDataPoints));

    return heartRateData;
  }
}
